import { render, staticRenderFns } from "./VehicleInsert.vue?vue&type=template&id=55ffde88&scoped=true&"
import script from "./VehicleInsert.vue?vue&type=script&lang=js&"
export * from "./VehicleInsert.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInsert.vue?vue&type=style&index=0&id=55ffde88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffde88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VMenu,VTextField})
